import {
    Button,
    Flex,
    Image,
    Text,
    useDisclosure,
    Input,
    Box,
    Checkbox,
} from "@chakra-ui/react";
import { colorMain } from "../../constants/themes";
import DynamicButton from "../Features/DynamicButton";
import BusinessItemsView from "../Features/BusinessItemsView";
import DynamicDrawer from "../Features/DynamicDrawer";
import ConfirmModal from "../Features/ConfirmModal";
import Truncate from "../Features/Truncate";
import React, { useState, useEffect } from "react";
import { renderMessageWithLinksDesc } from "../../utils/functions";
import Moment from "react-moment";

const BusinessTemplate = ({
    data,
    type,
    trigger,
    toast,
    trackCode,
    number,
    commonProps,
    opening,
    setOpening,
    verify,
    isToOpen,
    setIsToOpen,
    handleCloseThisModal,
    updating,
    paymentStatus,
    amount,
    paidBy,
    phoneNumberBy,
    transactionCode,
    handleCardClick,
    handlePaymentRecheck,
    handleRepay,
    selection,
    name,
    payType,
    dataSale,
    downloadPdf,
    callendar,
    location,
    urlOptions,
    setSelection,
    setAmount,
    venue,
    setSelectionDetails,
    urlOption,
    selectedOption,
    template,
}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [detail, setDetail] = useState(
        data?.data?.saledata?.contact_detail || ""
    );

    // Parse venue from detail if present
    useEffect(() => {
        const regex = /{([^}]+)}/;
        const match = detail?.match(regex);

        if (match) {
            const ven = match[1];
            const updatedContactDetail = detail?.replace(`{${ven}}`, "");
            setDetail(updatedContactDetail);
        }
    }, [detail]);



    const saleSettings = data?.data?.saledata?.sale_settings;
    const payDetailButton = saleSettings?.pay_detail_button;
    // Default to true if undefined/null to preserve existing design, unless explicitly disabled
    const hasSurveys = data?.data?.survey && data?.data?.all_surveys && data?.data?.all_surveys.length > 0;
    const isCustomPaymentEnabled = (payDetailButton !== false && payDetailButton !== "false" && payDetailButton !== 0) && !hasSurveys;

    const drawerData = {
        ...data,
        data: {
            ...data?.data,
            saledata: {
                ...data?.data?.saledata,
                sale_settings: {
                    ...data?.data?.saledata?.sale_settings,
                    pay_detail_type: "options"
                }
            }
        }
    };

    return (
        <Flex
            flexDir="column"
            color="gray.600"
            w="100%"
            p={4}
            py={3}
            mt={0}
            pt={0}
            justifyContent="space-between"
        >
            {(saleSettings?.add_about_collection === null ||
                saleSettings?.add_about_collection) &&
                type !== "Wallet" && (
                    <Flex flexDirection="column" mb={4}>
                        <Text fontSize="sm" color="gray.600" lineHeight="tall" as="div">
                            {detail && (
                                <Truncate text={detail} maxLength={50} lines={3} isRichText>
                                    {renderMessageWithLinksDesc(detail)}
                                </Truncate>
                            )}
                        </Text>
                    </Flex>
                )}

            <Flex
                alignItems="center"
                justifyContent="flex-start"
                gap={6}
                mb={6}
                wrap="wrap"
            >
                {saleSettings?.add_end_date && (
                    <Flex alignItems="center" gap={2}>
                        <Image
                            src={callendar}
                            objectFit="contain"
                            w="20px"
                            h="20px"
                            opacity="0.7"
                            alt="Date"
                        />
                        <Flex flexDir="column">
                            <Text
                                fontSize="xs"
                                fontWeight="bold"
                                color={colorMain}
                                mb={0}
                                lineHeight="shorter"
                            >
                                DATE
                            </Text>
                            <Text fontSize="sm" color="gray.600" fontWeight="medium" mb={0}>
                                <Moment
                                    format="D MMM YYYY"
                                    date={
                                        new Date(
                                            (data?.data.saledata.sales_date).toString().length === 16
                                                ? data?.data.saledata.sales_date / 1000
                                                : (data?.data.saledata.sales_date).toString().length ===
                                                    19
                                                    ? data?.data.saledata.sales_date / 1000000
                                                    : (data?.data.saledata.sales_date).toString().length >
                                                        10
                                                        ? data?.data.saledata.sales_date
                                                        : data?.data.saledata.sales_date * 1000
                                        )
                                    }
                                />
                            </Text>
                        </Flex>
                    </Flex>
                )}

                {venue && (
                    <Flex alignItems="center" gap={2}>
                        <Image
                            src={location}
                            objectFit="contain"
                            w="20px"
                            h="20px"
                            opacity="0.7"
                            alt="Venue"
                        />
                        <Flex flexDir="column">
                            <Text
                                fontSize="xs"
                                fontWeight="bold"
                                color={colorMain}
                                mb={0}
                                lineHeight="shorter"
                            >
                                VENUE
                            </Text>
                            <Text fontSize="sm" color="gray.600" fontWeight="medium" mb={0}>
                                {venue}
                            </Text>
                        </Flex>
                    </Flex>
                )}
            </Flex>

            {isCustomPaymentEnabled && (
                <>
                    <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color="gray.500"
                        mb={2}
                        textTransform="uppercase"
                        px={2}
                    >
                        {template === "tickets" ? "Select Ticket Type" : "Select Items"}
                    </Text>
                    <BusinessItemsView
                        urlOptions={urlOptions}
                        colorMain={colorMain}
                        setSelectionDetails={setSelectionDetails}
                        setSelection={setSelection}
                        setAmount={setAmount}
                        amount={amount}
                        urlOption={urlOption}
                        isDisabled={selectedOption}
                    />
                </>
            )}


            <Flex
                flexDir="column"
                w="100%"
                mt={5}
                mb={0}
            >
                {type === "Invoice" ||
                    type === "Sale" ||
                    type === "Collection" ||
                    type === "Wallet" ? (
                    <Flex flexDirection="column" p={2}>
                        {saleSettings
                            ?.contribute_button_visible && !hasSurveys && (
                                <DynamicButton
                                    onClickHandler={onOpen}
                                    buttonText={
                                        amount > 0
                                            ? `Pay KES ${Number(amount).toLocaleString()}`
                                            : (saleSettings?.contribute_button_name || "Pay")
                                    }
                                    isDisabled={isCustomPaymentEnabled ? (!amount || amount <= 0) : false}
                                    isLoading={trigger}
                                    colorMain={colorMain}
                                />
                            )}
                            
                        {hasSurveys && data.data.all_surveys.map((surveyItem) => (
                            <DynamicButton
                                key={surveyItem.id}
                                reqSurveyId={surveyItem.id}
                                onClickHandler={() => {
                                    if(commonProps?.setSurvey) commonProps.setSurvey(true);
                                    if(commonProps?.setReqSurveyId) commonProps.setReqSurveyId(surveyItem.id);
                                }}
                                buttonText={surveyItem.survey_name}
                                isLoading={trigger}
                                colorMain={colorMain}
                            />
                        ))}

                        {saleSettings?.download_receipt_visible &&
                            /statement/i.test(saleSettings?.download_receipt_name || "") && (
                                <DynamicButton
                                    onClickHandler={() => window.open("/statement", "_blank")}
                                    buttonText={saleSettings?.download_receipt_name}
                                    colorMain={colorMain}
                                />
                            )}
                    </Flex>
                ) : (
                    <></>
                )}
            </Flex>

            <DynamicDrawer
                isOpen={isOpen}
                onClose={onClose}
                contributionMode="pay"
                buttonText={
                    saleSettings?.contribute_button_name ||
                    "click to pay"
                }
                {...commonProps}
                data={drawerData}
                urlOptions={[]}
            />

            <DynamicDrawer
                isOpen={opening}
                onClose={() => setOpening(false)}
                contributionMode="pledge"
                buttonText={
                    saleSettings?.pledge_button_name ||
                    "Make a Pledge"
                }
                {...commonProps}
                data={drawerData}
                urlOptions={[]}
            />
            {!verify && (
                <ConfirmModal
                    isToOpen={isToOpen}
                    setIsToOpen={setIsToOpen}
                    handleCloseThisModal={handleCloseThisModal}
                    updating={updating}
                    paymentStatus={paymentStatus}
                    amount={amount}
                    paidBy={paidBy}
                    phoneNumberBy={phoneNumberBy}
                    transactionCode={transactionCode}
                    colorMain={colorMain}
                    handleCardClick={handleCardClick}
                    handlePaymentRecheck={handlePaymentRecheck}
                    handleRepay={handleRepay}
                    selection={selection}
                    enabled={
                        data &&
                        data?.data.saledata?.sale_settings?.download_receipt_visible
                    }
                    name={name}
                    orgName={
                        data && (data?.data.saledata.contact_name || "Anonymous")
                    }
                    number={number}
                    customMessage={
                        data && data?.data.saledata?.sale_settings?.customer_message
                    }
                    trackCode={trackCode}
                    payType={payType}
                    downloadMessage={
                        data &&
                        data?.data.saledata?.sale_settings?.download_receipt_name
                    }
                    details={dataSale}
                    downloadPdf={downloadPdf}
                    toast={toast}
                />
            )}



            <Flex w="100%" alignItems="center" justifyContent="center">
                {!data?.data.saledata.org_data.name && (
                    <Flex
                        alignItems="center"
                        color="gray.500"
                        letterSpacing={1}
                        fontSize="13"
                        fontWeight="bold"
                    >
                        <Text display="flex" alignItems="center" my={2} mt={1}>
                            &nbsp; Contact: {data?.data.saledata.org_data.name || "Anonymous"}
                            {`, ${data?.data.saledata.org_data.main_phone_number || ""}`}
                        </Text>
                    </Flex>
                )}
            </Flex>
        </Flex >
    );
};

export default BusinessTemplate;
